import { useEffect, useMemo, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import orgJson from "components/jsonData/orgnization.json";

import { accountTypeOptions } from "../Vendors/customFieldData";
import { ACCOUNT_NUMBER_REGEX, IFSC_REGEX, MAX_IFSC_LENGTH } from "../regexPatterns";
import axios from "axios";
import { fetchAsyncCreateAutomatedBank } from "redux/embrillProfileSlice";
import { fetchAsyncGetAutomatedBank } from "redux/embrillProfileSlice";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import { fetchAsyncUpdateAutomatedBank } from "redux/embrillProfileSlice";
import { FaPlusCircle } from "react-icons/fa";
import AccountUser from "./accountUser";
import { AiFillDelete, AiFillEdit } from "react-icons/ai";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import { fetchAsyncDeleteAccountUser } from "redux/embrillProfileSlice";
import CehekBankBalance from "./checkBankBalance";
import { MdAccountBalanceWallet } from "react-icons/md";
import { fetchAsyncRegisterStatus } from "redux/paymentSlice";
import { createOption } from "../createableSelect";
import { clientProjectOptions } from "jsFunctions/clientProjectOptions";
import CustomSelect from "components/CustomSelect";
import { fetchAsyncGetAccountUser } from "redux/embrillProfileSlice";
import InputFormControl from "../component/inputFormControl";

const {
  Box,
  Button,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td
} = require("@chakra-ui/react");

const AccountDetail = ({role}) => {
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit,setIsEdit] = useState(false);
  const [editUser,setEditUser] = useState("")
  const [allUserIds,setAllUserIds] = useState([])
  const [userIdOptions,setUserIdOptions] = useState([])
  const [bankData, setBankData] = useState({});
  const [isOpen, setIsOpen] = useState(false)
  const [isCheck, setIsCheck] = useState(false)
  const [selectedUserId,setSelectedUserId] = useState({})
  const currUser = useSelector((state) => state.auth.currUser);

  const fetchUserIdsOptions = async()=>{
    const allOptions = await clientProjectOptions('useId','useId',allUserIds);
    setUserIdOptions(allOptions)
  }

  useEffect(()=>{
    if(allUserIds && allUserIds.length > 0){
      fetchUserIdsOptions()
    }
  },[allUserIds])


  const [formData, setFormData] = useState({
    corId:"",
    aggId:"",
    aggName:"",
    urn:"",
    apiKey:"",
    bnk:{
      hol:"",
      acNo:"",
      ifc:"",
      typ:"",
      name:"",
      swt:"",
      bch:"",
      ct:"",
      st:""
    },
    users:[]
  });

  const userIdStatus = useMemo(()=>{
    if(selectedUserId && selectedUserId?.value){
      const uid = bankData?.useIds?.find((opt)=> opt?.useId === selectedUserId?.value);
      return uid?.sts || "Not Registered";
    }
    return "Not Registered"
  },[selectedUserId])

  useEffect(() => {
    const getAccountUser = async () => {
      if (currUser && currUser._id) {
        const res = await dispatch(fetchAsyncGetAccountUser(currUser._id));
        if (res?.payload?.isA) {
          if(res?.payload?.useId){
            setSelectedUserId({
              label:res?.payload?.useId,
              value:res?.payload?.useId
            });
          }
        }
    };
    }

    getAccountUser();
  }, [currUser?._id, dispatch,bankData]);

  useMemo(()=>{
    if(bankData && bankData?._id){
      setFormData({
        corId: bankData?.corId,
        aggId: bankData?.aggId,
        aggName: bankData?.aggName,
        urn: bankData?.urn,
        apiKey: bankData?.apiKey,
        bnk: {
          hol: bankData?.bnk?.hol,
          acNo: bankData?.bnk?.acNo,
          ifc: bankData?.bnk?.ifc,
          typ: bankData?.bnk?.typ,
          name: bankData?.bnk?.name,
          swt: bankData?.bnk?.swt,
          bch: bankData?.bnk?.bch,
          ct: bankData?.bnk?.ct,
          st: bankData?.bnk?.st,
        },
        users: bankData?.users,
      });
      setAllUserIds(bankData?.useIds)
    }
  },[bankData])
  const getBankDetails = ()=>{
    setIsLoading(true); 
    dispatch(fetchAsyncGetAutomatedBank())
      .then((res) => {
        
        setIsLoading(false); 
        if(res?.payload && res?.payload?._id){
          setBankData(res?.payload)
        }
      })
      .catch((error) => {
        setIsLoading(false); 
      }); 
    }

    const fetchAccountStatus = (data)=>{
      setIsLoading(true); 
      dispatch(fetchAsyncRegisterStatus(data))
        .then((res) => {
          if(res?.payload && res?.payload){
            const bank = res?.payload?.updatedBank;
            const useIDs = bank?.useIds || []
            setAllUserIds(useIDs)
          }
          else{
            addToast(`${res?.error?.message}`, { appearance: "error" });
          }
        })
        .catch((error) => {
          addToast(`error`, { appearance: "error" });
        }).finally(()=>{
          setIsLoading(false)
          // handleRefresh();
        });
      }
  useEffect(() => {
    getBankDetails();
  }, []);

  useEffect(()=>{
    if(selectedUserId && selectedUserId?.value !== ""){
      const uid = bankData?.useIds?.find((opt)=> opt?.useId === selectedUserId?.value)
      if(bankData && bankData?._id && uid && uid?.sts !== "Registered"){
        const data = {
          aggrId: bankData?.aggId, 
          aggrName: bankData?.aggName, 
          corpId: bankData?.corId, 
          userId: uid?.useId, 
          urn: bankData?.urn,
        };
        fetchAccountStatus(data)
      }
    }
  },[selectedUserId?.value])

    const handleRefresh = ()=>{
      getBankDetails();
    }

  const validate = () => {
    const newErrors = {};

    if (!selectedUserId && selectedUserId?.value) newErrors.userId = orgJson.required.userId;
    if (!formData.corId) newErrors.corpId = orgJson.required.corpId;
    if (!formData.bnk.acNo) newErrors[`bnk.acNo`] = orgJson.required.accNumber;
    if (!ACCOUNT_NUMBER_REGEX.test(formData.bnk.acNo)) newErrors[`bnk.acNo`] = orgJson.error.accNumber
    if (!formData.bnk.ifc) newErrors[`bnk.ifc`] = orgJson.required.ifsc;
    if (!IFSC_REGEX.test(formData.bnk.ifc)) newErrors[`bnk.ifc`] = orgJson.error.ifsc;
    if (!formData.bnk.typ || formData.bnk.typ === "") newErrors[`bnk.typ`] = orgJson.required.accountType;
    if (!formData.bnk.name) newErrors[`bnk.name`] = orgJson.required.bankName;

    setErrors(newErrors);   
    return Object.keys(newErrors).length === 0;
  };
 
  const toCamelCase = (value) => {
    return value
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

    if (name.startsWith("bnk.")) {
      const fieldName = name.split(".")[1];

      if (fieldName === "ifc") {
        formattedValue = value.toUpperCase();
        if (fieldName === "ifc" && formattedValue.length > MAX_IFSC_LENGTH) {
          return;
        }
      }
      if (fieldName === "acNo" || fieldName === "ifc") {
        setErrors((prev) => ({
          ...prev,
          [`bnk.${fieldName}`]: "",
        }));
      }
      setFormData((prev) => ({
        ...prev,
        bnk: {
                ...prev.bnk,
                [fieldName]: formattedValue,
              }

      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: formattedValue,
      }));
    }
  };
  const fetchBranchDetails = async (index) => {
    const codeToFetch = formData?.bnk?.ifc;
    if (!codeToFetch) return;

    try {
      const response = await axios.get(
        `https://ifsc.razorpay.com/${codeToFetch}`
      );
      const { BANK, BRANCH, CITY, STATE, SWIFT } = response.data;
      setFormData((prev) => ({
        ...prev,
        bnk: {
              ...prev.bnk,
              name: BANK,
              bch: BRANCH,
              swt: SWIFT,
              ct: CITY,
              st: STATE,
        }
      }));
    } catch (error) {
      addToast("Could not fetch branch details. Please check the IFSC or MICR code.", { appearance: "error" });
    }
  };
  const handleBlur = () => {
    if (IFSC_REGEX.test(formData.bnk.ifc)) {
      fetchBranchDetails();
    } else {
      setFormData((prev) => ({
        ...prev,
        bnk: {
              ...prev?.bnk,
              name: "",
              bch: "",
              swt: "",
              ct: "",
              st: ""
          }
      }));
    }
  };

  const handleCreate = (data) => {
    setIsLoading(true)
    dispatch(fetchAsyncCreateAutomatedBank(data))
      .then((res) => {
        if (res?.payload) {
          addToast(orgJson.success.accCreated, { appearance: "success" });
          handleRefresh()
        } else {
          addToast(res?.error?.message, { appearance: "error" });
        }
      })
      .catch((error) => {
        addToast(orgJson.error.generic, { appearance: "error" });
      }).finally(()=>{
        setIsLoading(false)
      });
  };
  const handleUpdate = (data) => {
    setIsLoading(true)
    dispatch(fetchAsyncUpdateAutomatedBank({id: bankData?._id,data}))
      .then((res) => {
        if (res?.payload) {
          addToast(orgJson.success.accUpdated, { appearance: "success" });
          handleRefresh()
        } else {
          addToast(res?.error?.message, { appearance: "error" });
        }
      })
      .catch((error) => {
        addToast(orgJson.error.generic, { appearance: "error" });
      }).finally(()=>{
        setIsLoading(false)
      });
  };

  const handleSave = (e)=>{
    e.preventDefault();
    if (validate()) {
        if(bankData && bankData?._id){
          handleUpdate({...formData,useIds:allUserIds})
        }else{
          handleCreate({...formData,useIds:allUserIds});
        }
    }
  }

  const handleEdit = (user)=>{
    setIsEdit(true);
    setEditUser(user);
    setIsOpen(true)
  }
  const handleUsers = (user,id)=>{
    if(id){
      const data = formData?.users.map((item)=>{
        if(item?._id === id){
          return {
            item,
            ...user,
          }
        }
        else return item;
      })
      setFormData({
        ...formData,
        users:data
      })
    }
    else{
      const data = formData?.users || []
      data.push(user)
      setFormData({
        ...formData,
        users:data
      })
    }
  }
 
  const handleClose = ()=>{
    setIsOpen(false);
    setIsEdit(false);
    setEditUser("")
  }
  if (isLoading) {
    return (
      <SpinnerLoader/>
    );
  }  
  
  const handleDelete = (user)=>{
    dispatch(fetchAsyncDeleteAccountUser({id:bankData?._id,userId:user._id})).then(() => {
      handleRefresh();
    });
  }

  const handleCreateUserId = (option)=>{
    const ids = [...allUserIds];
    ids.push({
      useId:option.value,
      sts:''
    })
    setAllUserIds(ids);
    setSelectedUserId(option)
  }
  const handleEditUserId = (option, newValue) => {
    if (!option || option.value === newValue) {
      return;
    }
    const duplicateUser = allUserIds.find(user => user.useId === newValue);
    if (duplicateUser) {
      addToast('UserID should be unique!', { appearance: 'error' });
      return;
    }
    const updatedUserIds = allUserIds.map(user => 
      user.useId === option.value ? { useId: newValue, sts: '' } : user
    );
    setAllUserIds(updatedUserIds);
    setSelectedUserId({ label: newValue, value: newValue });
    if (formData?.users && Array.isArray(formData.users)) {
      const updatedUsers = formData.users.map(user => {
        if (user.useId === option.value) {
          return { ...user, useId: newValue };
        }
        return user;
      });
      setFormData({
        ...formData,
        users: updatedUsers
      });
    }
  };

  const handleDeleteUserId = (option) => {
    const filteredArray = allUserIds.filter((obj) => obj.useId !== option.value);
    setAllUserIds(filteredArray);
    if (selectedUserId?.value === option.value) {
      setSelectedUserId(null); 
    }
    if (formData?.users && Array.isArray(formData.users)) {
      const updatedUsers = formData.users.map(user => {
        if (user.useId === option.value) {
          return { ...user, useId: "" };
        }
        return user;
      });
      setFormData({
        ...formData,
        users: updatedUsers
      });
    }
  };

  
  return (
    <>
      <Box display="flex">
        <Form className="addForm mt-0 organization-acount">
          <div className="form-card">
            <h3 className="mt-0">Bank Details</h3>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label><span className="span-star">Account Holder*</span></Form.Label>
                  <InputFormControl
                    placeholder="Account Holder Name"
                    name="bnk.hol"
                    value={formData?.bnk?.hol}
                    handleChange={(e) => handleChange(e)}
                  />
                </Box>
              </Col>
              <Col></Col>
            </Row>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>
                    <span className="span-star">Account Number*</span>
                  </Form.Label>
                  <InputFormControl
                    placeholder="Enter Account Number"
                    name="bnk.acNo"
                    value={formData?.bnk?.acNo}
                    handleChange={(e) => handleChange(e)}
                    isInvalid={!!errors[`bnk?.acNo`]}
                  />
                </Box>
                <p className="form_error"> {errors[`bnk.acNo`]}</p>
              </Col>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>
                    <span className="span-star">IFSC Code*</span>
                  </Form.Label>
                  <InputFormControl
                    name={`bnk.ifc`}
                    placeholder="Enter IFSC Code"
                    value={formData?.bnk?.ifc}
                    handleChange={(e) => handleChange(e)}
                    handleBlur={() => handleBlur()}
                    isInvalid={!!errors[`bnk?.ifc`]}
                  />
                </Box>
                <p className="form_error"> {errors[`bnk.ifc`]}</p>
              </Col>
            </Row>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>
                    <span className="span-star">Account Type*</span>
                  </Form.Label>
                  <Form.Select
                    name={`bnk.typ`}
                    value={formData?.bnk?.typ}
                    onChange={(e) => handleChange(e)}
                    isInvalid={!!errors[`bnk?.typ`]}
                    className="custom--dropdown-container"
                  >
                    {accountTypeOptions.map((option) => (
                      <option key={option.value} value={option.id}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                </Box>
                <p className="form_error"> {errors[`bnk.typ`]}</p>
              </Col>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>
                    <span className="span-star">Bank Name*</span>
                  </Form.Label>
                  <InputFormControl
                    name={`bnk.name`}
                    placeholder="Enter Bank Name"
                    value={formData?.bnk?.name}
                    handleChange={(e) => handleChange(e)}
                    isInvalid={!!errors[`bnk.name`]}
                  />
                </Box>
                <p className="form_error"> {errors[`bnk.name`]}</p>
              </Col>
            </Row>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>SWIFT Code</Form.Label>
                  <InputFormControl
                    name={`bnk.swt`}
                    placeholder="Enter SWIFT Code"
                    value={formData?.bnk?.swt}
                    handleChange={(e) => handleChange(e)}
                  />
                </Box>
              </Col>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>Branch Name</Form.Label>
                  <InputFormControl
                    type="text"
                    name={`bnk.bch`}
                    placeholder="Branch Name"
                    value={formData?.bnk?.bch}
                    handleChange={(e) => handleChange(e)}
                  />
                </Box>
              </Col>
            </Row>

            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>City</Form.Label>
                  <InputFormControl
                    name={`bnk.ct`}
                    placeholder="City"
                    value={formData?.bnk?.ct}
                    handleChange={(e) => handleChange(e)}
                  />
                </Box>
              </Col>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>State</Form.Label>
                  <InputFormControl
                    name={`bnk.st`}
                    placeholder="State"
                    value={formData?.bnk?.st}
                    handleChange={(e) => handleChange(e)}
                    isInvalid={!!errors[`errors?.bnk?.st`]}
                  />
                </Box>
              </Col>
            </Row>

            <hr className="hr-6" />

            <h3 className="mt-0">
              Account Details{" "}
              {selectedUserId && selectedUserId?.value && 
              <span className="badge badge-red mx-3 acc-status-badge">
                {userIdStatus || "Not Registered"}
              </span>
              }
            </h3>
            <Box className="account-form">
              <Row>
                <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label>
                      <span className="required">User ID*</span>
                    </Form.Label>
                    
                  <CustomSelect
                     options={userIdOptions}
                     placeHolder={<div>Select User ID</div>}
                     onChange={(newValue) => {
                      setSelectedUserId(newValue);
                    }}
                    onCreateOption={(e) => {
                      handleCreateUserId(createOption(e));
                    }}
                    onDeleteOption={(option) => {
                      handleDeleteUserId(option);
                    }}
                    onEditOption={(option, newValue) => {
                      handleEditUserId(option, newValue);
                    }}
                     isSearchable
                     defaultValue={selectedUserId}
                     name="userid"
                     role={role}
                   />
                  </Box>
                  <p className="form_error"> {errors[`userId`]}</p>
                </Col>
                <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label>
                      <span className="required">Corp ID*</span>
                    </Form.Label>
                    <InputFormControl
                      placeholder="Corp ID"
                      name="corId"
                      value={formData?.corId}
                      handleChange={(e) => handleChange(e)}
                    />
                  </Box>
                  <p className="form_error"> {errors[`corpId`]}</p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label>Aggregate ID </Form.Label>
                    <InputFormControl
                      placeholder="Aggregate ID"
                      name="aggId"
                      value={formData?.aggId}
                      handleChange={(e) => handleChange(e)}
                    />
                  </Box>
                </Col>
                <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label>Aggregate Name</Form.Label>
                    <InputFormControl
                      placeholder="Aggregate Name"
                      name="aggName"
                      value={formData?.aggName}
                      handleChange={(e) => handleChange(e)}
                    />
                  </Box>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label>URN</Form.Label>
                    <InputFormControl
                      placeholder="URN Number"
                      name="urn"
                      value={formData?.urn}
                      handleChange={(e) => handleChange(e)}
                    />
                  </Box>
                </Col>
                <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label>API key</Form.Label>
                    <InputFormControl
                      placeholder="API KEY"
                      name="apiKey"
                      value={formData?.apiKey}
                      handleChange={(e) => handleChange(e)}
                    />
                  </Box>
                </Col>
              </Row>

              <hr className="hr-6" />
              <Box display="flex">
                <h3 className="mt-0">Account Users</h3>
                <Button className="mt-0 add-user-btn" onClick={() => setIsOpen(true)}>
                  <FaPlusCircle className="add-project-icon" size={15} />
                </Button>
              </Box>
              <Table className="account-user-table" border={1}>
                <Thead>
                  <Tr>
                    <Th>No</Th>
                    <Th>Name</Th>
                    <Th>email</Th>
                    <Th>phone</Th>
                    <Th>mobile</Th>
                    <Th>user ID</Th>
                    <Th>Status</Th>
                    <Th className="action-heading">Action</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {formData?.users && formData?.users?.length
                    ? formData?.users?.map((user, index) => {
                        return (
                          <Tr>
                            <Td>{index + 1}</Td>
                            <Td>{user?.name}</Td>
                            <Td>{user?.mail}</Td>
                            <Td>{user?.ph}</Td>
                            <Td>{user?.mob}</Td>
                            <Td>{user?.useId}</Td>
                            <Td color={`${user?.isA ? "green" : "red"}`}>
                              {user?.isA ? "Active" : "Not-Active"}
                            </Td>
                            <Td className="action-data">
                              <Box display="flex">
                                <AiFillEdit
                                  style={{
                                    cursor: "pointer",
                                    color: "blue",
                                    marginLeft: "2px",
                                  }}
                                  size={16}
                                  onClick={(e) => {
                                    handleEdit(user);
                                  }}
                                />
                                <AiFillDelete
                                  style={{
                                    cursor: "pointer",
                                    color: "#c3473e",
                                    marginLeft: "12px",
                                  }}
                                  size={16}
                                  onClick={(e) => {
                                    ConfirmationDialog({
                                      title: `Are you sure? you want to delete user <span style="color: #d33">Name : ${
                                        user?.name && user?.name
                                      }</span>.`,
                                      text: "This action cannot be undone.",
                                      icon: "warning",
                                      confirmButtonText: "Delete",
                                      cancelButtonText: "Cancel",
                                      onConfirm: () => {
                                        handleDelete(user);
                                      },
                                    });
                                  }}
                                />
                              </Box>
                            </Td>
                          </Tr>
                        );
                      })
                    : ""}
                </Tbody>
              </Table>
            </Box>
          </div>
          <hr className="hr-6" />

          <Button className="btn save-btn mt-3" onClick={(e) => handleSave(e)}>
            Save
          </Button>
        </Form>
        {isOpen && (
          <AccountUser
            isOpen={isOpen}
            onClose={handleClose}
            handleUser={(user, id) => {
              handleUsers(user, id);
            }}
            editData={editUser}
            isEdit={isEdit}
            userIds={allUserIds}
            allUsers = {formData?.users || []}

          />
        )}
        <></>

        {bankData && bankData?._id && (
          <Button
            onClick={() => setIsCheck(true)}
            disabled={!bankData?._id}
            className="check-balance-btn"
          >
            <MdAccountBalanceWallet size={20} className="m-1" />
            Check Balance
          </Button>
        )}
      </Box>
      {isCheck && (
        <CehekBankBalance
          isOpen={isCheck}
          onClose={() => setIsCheck(false)}
          accData={formData}
          userIds={allUserIds}
        />
      )}
    </>
  );
};

export default AccountDetail;
